/**
 * Created by Maxim B. on 07/04/20.
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'curr-image-view-popup-dialog',
  templateUrl: './image-view-popup-dialog.component.html',
  styleUrls: ['./image-view-popup-dialog.component.scss']
})
export class ImageViewPopupDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ImageViewPopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
  }

}
